import React from 'react';
import * as Yup from 'yup';
import { ErrorMessage, Field, FieldArray, Form, Formik, useFormikContext } from 'formik';
import { Button, Col, FormGroup, FormText, Input, Label, Row, Table } from 'reactstrap';
import axios from 'axios';
import { REPORT_CONFIG_LIST_URL } from '../../Routes';
import { connect } from 'react-redux';
import Container from 'reactstrap/es/Container';

const SubmitBtn = () => {
  const { dirty, isSubmitting } = useFormikContext();
  if (!dirty) return null;
  return (
    <Button color='primary' disabled={isSubmitting}>
      Save
    </Button>
  );
};

const ColumnList = ({ swap, push, insert, remove, form }) => {
  const [rowHighlight, setRowHighlight] = React.useState(-1);
  const [json, setJson] = React.useState('');

  const values = form?.values?.columns;

  const renderAdd = () => {
    return (
      <tr>
        <td colSpan={5}>
          <Button
            type='button'
            outline
            onClick={() => {
              setRowHighlight(values?.length || 0);
              push({ size: 20 });
            }}
          >
            +
          </Button>
        </td>
      </tr>
    );
  };

  const excelColumn = (i) => {
    return i > 25 ? 'A' + String.fromCharCode('A'.charCodeAt(0) + i - 26) : String.fromCharCode('A'.charCodeAt(0) + i);
  };

  const renderList = () => {
    if (values?.length === 0) return null;
    return values?.map((e, i) => (
      <tr key={excelColumn(i)} className={i === rowHighlight ? 'bg-info' : null}>
        <td>
          <Button outline onClick={() => insert(i, { title: '', name: '', size: 20, type: '' })}>
            +
          </Button>
          {i === values?.length - 1 ? (
            <span>&nbsp;</span>
          ) : (
            <Button
              type='button'
              outline
              onClick={() => {
                swap(i, i + 1);
                setRowHighlight(i + 1);
              }}
            >
              🞃
            </Button>
          )}
          {i === 0 ? (
            <span>&nbsp;</span>
          ) : (
            <Button
              type='button'
              outline
              onClick={() => {
                swap(i, i - 1);
                setRowHighlight(i - 1);
              }}
            >
              🞁
            </Button>
          )}
        </td>
        <td>{excelColumn(i)}</td>
        <td>
          <Field name={`columns[${i}].title`} as={Input} />
        </td>
        <td>
          <Field name={`columns[${i}].name`} as={Input} />
        </td>
        <td>
          <Field name={`columns[${i}].size`} as={Input} />
        </td>
        <td>
          <Field name={`columns[${i}].type`} as={Input} type='select'>
            <>
              <option value=''>Text</option>
              <option value='number'>Number</option>
            </>
          </Field>
        </td>
        <td>
          <Button type='button' color='danger' outline onClick={() => remove(i)}>
            -
          </Button>
        </td>
      </tr>
    ));
  };
  return (
    <>
      {renderList()}
      {renderAdd()}
      <tr>
        <td colSpan='7'>
          <FormGroup>
            <Input type='textarea' name='json' value={json} onChange={(e) => setJson(e.target.value)} />
            <Button
              onClick={() => {
                const payload = JSON.parse(json);
                const title = payload?.title;
                let result = title?.reduce((result, currentValue, index) => {
                  return [
                    ...result,
                    { name: payload?.header?.[index], title: currentValue, size: payload?.size?.[index] },
                  ];
                }, []);
                result.forEach((e) => push(e));
                console.log(result);
              }}
            >
              Convert from Json
            </Button>
          </FormGroup>
        </td>
      </tr>
    </>
  );
};

const ConfigItemPage = ({ values, history, match, onLoad }) => {
  const code = match?.params?.code;

  React.useEffect(() => {
    onLoad(code);
  }, []);

  const initialValues = {
    seq: 0,
    code: '',
    title: '',
    query: '',
    bank: '',
    columns: [],
    ...values,
  };

  const validationSchema = Yup.object().shape({
    code: Yup.string().required('Nhập mã báo cáo'),
    title: Yup.string().required('Nhập tên báo cáo'),
    query: Yup.string().required('Nhập câu SQL'),
    bank: Yup.string().required('Nhập mã ngân hàng, eg: VCB'),
  });

  const doSubmit = async (values, formik) => {
    try {
      formik.setSubmitting(true);
      await axios.post('/api/report-configs', values);
      formik.setSubmitting(false);
      history.push(REPORT_CONFIG_LIST_URL);
    } catch (err) {
    } finally {
      formik.setSubmitting(false);
    }
  };

  if (!values) return null;

  return (
    <Container fluid className='config-item pt-3'>
      <h3 className='text-primary'>{values?.title || 'NEW'}</h3>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={doSubmit}>
        <Form>
          <Row>
            <Col md={3}>
              <FormGroup>
                <Label>Code</Label>
                <Field name='code' as={Input} />
                <ErrorMessage name='code' component={FormText} color='danger' />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label>Bank code</Label>
                <Field name='bank' as={Input} />
                <ErrorMessage name='bank' component={FormText} color='danger' />
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Label>Index</Label>
                <Field name='seq' as={Input} />
              </FormGroup>
            </Col>
            <Col md={5}>
              <FormGroup>
                <Label>Report title</Label>
                <Field name='title' as={Input} />
                <ErrorMessage name='title' component={FormText} color='danger' />
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup>
                <Label>Query</Label>
                <Field name='query' as={Input} type='textarea' />
                <ErrorMessage name='query' component={FormText} color='danger' />
              </FormGroup>
            </Col>
          </Row>

          <Table borderless size='sm'>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>Title</th>
                <th>Name</th>
                <th>Size</th>
                <th>Type</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <FieldArray name='columns' component={ColumnList} />
            </tbody>
          </Table>
          <div className='d-flex justify-content-between'>
            <Button outline onClick={() => history.push('/report-configs')}>
              Back
            </Button>
            <SubmitBtn />
          </div>
        </Form>
      </Formik>
    </Container>
  );
};

const fetchReportConfigItem = (reportName) => async (dispatch) => {
  try {
    dispatch({ type: 'fetch_report_config_item_start' });
    let payload = {};
    if (reportName !== 'new') {
      let res = await axios.get(`/api/report-configs/${reportName}`);
      payload = res.data;
    }
    dispatch({ type: 'fetch_report_config_item_success', payload });
  } catch (err) {
    dispatch({ type: 'fetch_report_config_item_error', payload: err });
    throw err;
  }
};

const mapStateToProps = (state) => {
  return { values: state?.reportConfigs?.selectedItem };
};

const mapDispatchToProps = { onLoad: fetchReportConfigItem };

export default connect(mapStateToProps, mapDispatchToProps)(ConfigItemPage);
